// extracted by mini-css-extract-plugin
module.exports = {"one":"Bucket_one__1-jx_","textareaHolder":"Bucket_textareaHolder__3SaiR","textarea":"Bucket_textarea__PExoB","uploadX":"Bucket_uploadX__1ji8Y"};